import axios from 'axios';
import { app_version } from './Utils';
import moment from 'moment';

export const serverUrl = `${process.env.REACT_APP_SERVER_URL || ''}api`;

axios.defaults.baseURL = serverUrl;
axios.defaults.headers.post['Content-Type'] = 'application/json';
function setCompanyCodeHeader() {
    let companyCode = localStorage.getItem("Company-code");
    if (companyCode) {
        axios.defaults.headers.common['Company'] = companyCode;
    }
}

function saveCompanyCodeHeader(companyCode) {
    localStorage.setItem("Company-code", companyCode);
    //axios.defaults.headers.common['Company'] = companyCode;
}

const ArthaGateway = {
    validateLogin: async function (companyCode, username, password) {
        try {
            const formData = new URLSearchParams({ username, password }).toString();
            saveCompanyCodeHeader(companyCode);
            let response = await axios.post('/user/validate', formData, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::validateLogin ->" + error);
            throw error;
        }
        return false;
    },
    getAccounts: async function (name = "", type = 0, pageNumber = 1, pageSize = 10) {
        try {
            const params = { name, pageNumber, pageSize, type };
            setCompanyCodeHeader();
            let response = await axios.get('/accounting/account', { params });
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getDealers ->" + error);
            throw error;
        }
        return undefined;
    },
    getTransactions: async function (from, to, accountId, siteId, pageNumber = 1, pageSize = 10) {
        try {
            setCompanyCodeHeader();
            if (pageNumber <= 0) {
                pageNumber = 1;
            }
            const params = { from, to, accountId, siteId, pageNumber, pageSize };
            let response = await axios.get('/accounting/account/' + accountId + "/transaction", { params });
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->" + error);
            throw error;
        }
        return undefined;
    },
    getCustomerSlips: async function (from, to, accountId, pageNumber = 1, pageSize = 10) {
        try {
            setCompanyCodeHeader();
            const params = { from, to, accountId, pageNumber, pageSize };
            let response = await axios.get('/customer/slip/', { params });
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getCustomerSlips ->" + error);
            throw error;
        }
        return undefined;
    },
    saveCustomerSlip: async function (slip, file) {
        try {
             let formData = new FormData();
            formData.append("slip", JSON.stringify(slip));
            formData.append("file", file);
            let response = await axios.post(serverUrl + '/customer/slip/', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::saveCustomerSlip ->" + error);
            throw error;
        }
        return undefined;
    }
}

export default ArthaGateway;